<template>
    <div>
      <div class="row topCardGrid cardLine">
          <sp-card :valor="totalSempre" :descricao="$t('atendimento.cardRecebidas')" :footerText="footerText"/>
          <sp-card :valor="concluidasSempre" :descricao="$t('atendimento.cardConcluidas')" :footerText="footerText"/>
          <sp-card :valor="canceladasSempre" :descricao="$t('atendimento.cardCanceladas')" :footerText="footerText"/>
          <sp-card tema='info' stripe='none' :valor="TMASempre" sufix="dias" :descricao="$t('atendimento.cardTMA')" :footerText="footerText"/>
      </div>

      <div class="row topCardGrid cardLine">
          <sp-card :valor="totalMes" :descricao="$t('atendimento.cardRecebidasMes')" :footerText="footerText"/>
          <sp-card :valor="concluidasMes" :descricao="$t('atendimento.cardConcluidasMes')" :footerText="footerText"/>
          <sp-card :valor="canceladasMes" :descricao="$t('atendimento.cardCanceladasMes')" :footerText="footerText"/>
          <sp-card tema='info' stripe='none' :valor="TMAMes" sufix="dias" :descricao="$t('atendimento.cardTMAMes')" :footerText="footerText"/>
      </div>

      <div class="row grafico-segmentado">
          <div class="flex md6 xs12 ">
              <Donut v-bind:data="chartDataD" :cores="cores"
              :options="optionsD"
              :titulo="donutTitle"
              :tooltipText="tooltipDonutDemandaCanais"
              :footerText="$t(footerText)"
              :footerComplementar="$t(footerComplementar)"
              ></Donut>
          </div>
          <div class="flex md6 xs12 ">
              <Linha v-bind:data="chartDataL" :cores="cores" :options="optionsL"
                  :title="'atendimento.canalDeAtendimentoSemestral'"
                  :tooltipText="'atendimento.canalDeAtendimentoSemestralTooltip'"
                  :footerText="$t(footerText)"
                  :footerComplementar="$t(footerComplementar)">
              </Linha>
          </div>
      </div>

      <div class="row grafico-alto">
          <div class="flex md12 xs12 " >
              <Linha v-bind:data="chartDataEntradaSaida.chartData"
                  :options="chartDataEntradaSaida.options"
                  :title="'estoque.entradaSaida'"
                  :tooltipText="'estoque.entradaSaidaTooltip'"
                  classe="tamanho-lg-canvas"
                  :footerText="$t(footerText)"
                  :footerComplementar="$t(footerComplementar)"
              ></Linha>
          </div>
      </div>

    </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import Donut from '@/components/statistics/charts/GraficoDonut.vue'
import Linha from '@/components/statistics/charts/GraficoLinha.vue'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import SpCard from '@/components/ui/cards/SP360Card'
import lastUpdate from '@/utils/LastUpdate'
export default {
  name: 'atendimento-soliciatcoes',
  mixins: [lastUpdate],
  components: {
    Donut,
    Linha,
    SpCard,
  },
  data: () => ({
    chartDataEntradaSaida: {},
    cores: [CorUtils.getCorPorNomeSp360('verde-medio'),
      CorUtils.getCorPorNomeSp360('azul-columbia-medio'),
      CorUtils.getCorPorNomeSp360('purpura-escuro'),
      CorUtils.getCorPorNomeSp360('vermelho-medio'),
      CorUtils.getCorPorNomeSp360('amarelo-medio'),
    ],
    tooltipDonutDemandaCanais: {
      content: 'atendimento.canalDeAtendimentoMensalTooltip',
      placement: 'bottom',
    },
    donutTitle: '',
    totalSempre: 0,
    concluidasSempre: 0,
    canceladasSempre: 0,
    TMASempre: 0,
    totalMes: 0,
    concluidasMes: 0,
    canceladasMes: 0,
    TMAMes: 0,
    chartData: {},
    chartDataD: {},
    chartDataL: {},
    optionsVB: {},
    options: {},
    optionsD: {},
    optionsL: {},
    consolidado: {},
  }),
  computed: {
    TaxaFinalizacaoBaixa: function () {
      return this.TaxaFinalizacao < Constantes.PARAMETROS_DASHBOARD.CANAIS_DE_ENTRADA.TOLERANCIAS.TAXA_FINALIZACAO
    },
    AltoTMA: function () {
      return this.TMA > Constantes.PARAMETROS_DASHBOARD.CANAIS_DE_ENTRADA.TOLERANCIAS.TMA_ALTO
    },
  },
  created () {
    this.chartDataEntradaSaida.chartData = {}
    Promise.all([
      this.$store.dispatch('servicos156/buscarSolicitacoesPorCanal'),
      this.$store.dispatch('servicos156/buscarSolicitacoesConsolidado'),
    ])
      .then(
        (respostas) => {
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = new Date(respostas[0].data.data_referencia_dado)
          this.footerText = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef.toLocaleDateString('pt-BR') })

          this.disparar(respostas[0].data.lastUpdate)
          this.canais = respostas[0].data
          this.consolidado = respostas[1].data
          this.calcularDados()
          this.populateDonutChart()
          this.populateLineChart(6)
          this.chartDataEntradaSaida = this.populateLineChartEntradaSaida(_.cloneDeep(this.dadosOrdenados), 'estoque.entradaSaidaEixoX', 'estoque.entradaSaidaEixoY')
          this.populateCards()
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },
  methods: {
    formatarNumeros (num) {
      return MethGlob.thousandSeparator(num)
    },
    dadosDoUltimoMesFechado (dados) {
      let canais = new Array()
      dados.forEach(canal => {
        let item = {}
        item.de_canal = canal.de_canal
        if(canal.historico.length > 1) {
            let historico = canal.historico[1] /* Último mês fechado */
            item.ano = historico.ano
            item.mes = historico.mes
            item.perc = historico.perc_mes
            item.total = historico.total_mes
            canais.push(item)
        }
      })
      this.donutTitle = ' ' + this.$t('atendimento.canalDeAtendimentoMensal') + MethGlob.mapeiaMesAbreviacao(canais[0].mes).nome + '/' + canais[0].ano
      return canais
    },

    calcularDados () {
      this.dadosOrdenados = _.orderBy(this.canais.data, 'perc', 'desc')
    },

    tooltipsPercCallback () {
      return {
        label: function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label + '  ' || ''
          label += tooltipItem.yLabel
          if (label) {
            label += '%'
          }
          return label
        },
      }
    },

    tooltipsTotalCallback () {
      return {
        label: function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label + '  ' || ''
          label += MethGlob.thousandSeparator(tooltipItem.yLabel)
          return label
        },
      }
    },

    populateCards () {
      this.totalSempre = this.consolidado.data[1].total
      this.concluidasSempre = this.consolidado.data[1].finalizadas
      this.canceladasSempre = this.consolidado.data[1].canceladas
      this.TMASempre = parseInt(this.consolidado.data[1].tempo_medio_atendimento)
      this.totalMes = this.consolidado.data[2].recebidas
      this.concluidasMes = this.consolidado.data[2].finalizadas
      this.canceladasMes = this.consolidado.data[2].canceladas
      this.TMAMes = parseInt(this.consolidado.data[2].tempo_medio_atendimento)
    },

    simpleDataset (dados, backgroundColor, borderColor) {
      let chartData = { labels: [], datasets: [] }
      let dataset = { data: [] }

      dados.forEach(element => {
        chartData.labels.push(element.de_canal)
        dataset.data.push(element.perc)
      })

      dataset.backgroundColor = backgroundColor
      dataset.borderColor = borderColor

      chartData.datasets.push(dataset)

      return chartData
    },

    populateDonutChart () {
      let dados = this.dadosDoUltimoMesFechado(this.dadosOrdenados)
      this.optionsD = {
        responsive: true,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          // mode: 'index',
          intersect: true,
          callbacks: MethGlob.percentualLabelCallback(true, false, 'pie'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 25,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            font: {
              size: 14,
              weight: 'bold',
            },
            formatter: (value, ctx) => {
              return MethGlob.formataPercentual(value)
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
          },
        },
      }
      let palette = this.$store.getters.palette
      this.chartDataD = this.simpleDataset(dados, this.cores.slice(0, dados.lenght), palette.transparent)
    },

    // Periodo não Pode Ser Invalido e deve ser maior que 0;
    populateLineChart (periodo) {
      if (!periodo) {
        throw new Error('Periodo Do Line Chart Invalido. Esperando: >0 recebeu : ' + periodo)
      } else {
        let datasets = []
        let cores = _.cloneDeep(this.cores)
        let Labels = ''
        this.dadosOrdenados.forEach(canal => {
          let historico = canal.historico.slice(0, periodo)

          if (historico.length < periodo) {
            let num = periodo - historico.length
            for (let i = 0; i < num; i++) {
              historico.push({ ano: 0, mes: 0, perc_mes: null })
            }
          }
          else { /* Caso o historico tenha o mesmo tamanho do periodo
                   significa que suas labels de ano e mes estão corretas */
            Labels = _.map(historico, (n) => {
              return MethGlob.mapeiaMesAbreviacao(n.mes).abrev + '/' + n.ano
            })
          }
          let dataMap = _.map(historico, (n) => {
            return n.perc_mes
          })

          let corDataset = cores.shift()
          let dataset = {
            label: canal.de_canal,
            fill: false,
            backgroundColor: corDataset,
            borderColor: corDataset,
            data: _.reverse(dataMap),
            yAxisID: 'y-axis-1',
          }
          datasets.push(dataset)
        })

        this.chartDataL = {
          datasets: datasets,
          labels: _.reverse(Labels),
        }

        this.optionsL = {
          responsive: true,
          title: {
            display: false,
            text: '',
          },
          tooltips: {
            intersect: true,
            callbacks: MethGlob.percentualLabelCallback(true, false, 'line'),
          },

          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.$t('atendimento.xaxislabeltime'),
              },
            }],
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                position: 'left',
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: this.$t('atendimento.yaxislabel'),
                },
              },
            ],
          },
        }
      }
    },
    populateLineChartEntradaSaida (d, legendaX, legendaY) {
      let tamAmostra = Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_MESES_GRAFICO_LINHA_SOLICITACOES_FINALIZADAS
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = this.cores.slice(0, d.length)
      let lbl = []
      d.forEach(canal => {
        if (canal.historico.length < tamAmostra) {
          let num = tamAmostra - canal.historico.length
          for (let i = 0; i < num; i++) {
            /* Valores que serão ignorados para a linha começar no meio
                                do gráfico */
            canal.historico.push({ ano: 0, mes: 0, total_mes: null })
          }
        }
        canal.historico = _.slice(canal.historico, 1, tamAmostra)
        _.reverse(canal.historico)
      })

      d.forEach(canal => {
        let vetorLabels = []
        for (let n of canal.historico) {
          if (n.mes > 0 && n.ano > 0) { vetorLabels.push(MethGlob.mapeiaMesAbreviacao(n.mes).abrev + '/' + n.ano) }
        }
        if (lbl.length < vetorLabels.length) { lbl = vetorLabels }

        let dataMap = _.map(canal.historico, (n) => {
          return n.total_mes
        })
        let totalData = null /* verifica se dataset está zerado */
        dataMap.forEach(dadoMapeado => {
          totalData = dadoMapeado
          if(dadoMapeado != null)
            return totalData
        })
        if(totalData != null){ /* Caso dataset esteja zerado, não adicionar */
          let corDataset = cores.shift()
          let dataset = {
            label: canal.de_canal,
            fill: false,
            backgroundColor: corDataset,
            borderColor: corDataset,
            data: dataMap,
            yAxisID: 'y-axis-1',
          }
          datasets.push(dataset)
        }
      })
      chartData = {
        datasets: datasets,
        labels: lbl,
      }

      options = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 4,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          // mode: 'index',
          intersect: true,
          callbacks: this.tooltipsTotalCallback(),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => MethGlob.thousandSeparator(value),
              },
              id: 'y-axis-1',
              type: 'logarithmic',
              position: 'left',
              display: true,
              ticks:{
                maxTicksLimit: 20,
                autoSkip: true,
                callback: (value) => MethGlob.thousandSeparator(value),
              },
              scaleLabel: {
                display: true,
                labelString: this.$t(legendaY || 'LegendaY'),
              },
            },
          ],
        },
      }
      return { chartData, options }
    },

  }, // Methods
}
</script>

<style lang='scss'>
  .cardLine{
    .va-card__body{
      height: 8rem;
    }
  }
</style>
